<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="!mapForm.form.valid || (this.invalidQueryMsg !== '')"
            [title]="(data.isEditMode ? 'Edit' : 'Add') + ' SERVER'">

  <mat-tab-group animationDuration="0" class="server-tabs" (selectedTabChange)="onTabChanged($event)">
    <mat-tab [label]="settingsTabName">
      <div class="setting-tab-content">
        <form #mapForm="ngForm" autocomplete="off" class="setting-tab-form-content">
          <div class="general">
            <arm-form-title>GENERAL</arm-form-title>
            <mat-form-field class="fullWidth">
              <mat-label>Name</mat-label>
              <input matInput required [(ngModel)]="data.selectedItem.name" maxlength="255" name="name">
              <mat-error>
                Name is <strong>required</strong>
              </mat-error>
            </mat-form-field>

            <div class="host-and-port">
              <mat-form-field class="fullWidth">
                <mat-label>{{ data.selectedItem.type === 'LDAP' || data.selectedItem.type === 'UMP' ? 'Host:' : 'Tenant Id:' }}</mat-label>
                <input matInput required [(ngModel)]="data.selectedItem.host" maxlength="255" name="host">
                <mat-error>
                  Host is <strong>required</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field *ngIf="data.selectedItem.type === 'LDAP'">
                <mat-label>Port</mat-label>
                <input [(ngModel)]="data.selectedItem.port" matInput max="65535"
                       min="1" name="port" type="number">
              </mat-form-field>
            </div>

            <div class="bind-and-password">
              <mat-form-field class="fullWidth">
                <mat-label>{{ data.selectedItem.type === 'LDAP' ? 'Bind DN:' : data.selectedItem.type === 'LDAP' ? 'Client Id:' : 'User:' }}</mat-label>
                <input autocomplete="new-password" matInput required [(ngModel)]="data.selectedItem.dn" maxlength="255"
                       name="dn">
                <mat-error>
                  {{ 'LDAP' ? 'Bind DN:' : 'Client Id:' }} is <strong>required</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field class="fullWidth">
                <mat-label>{{ data.selectedItem.type === 'LDAP' || data.selectedItem.type === 'UMP' ? 'Password:' : 'Client Secret:' }}</mat-label>
                <input type="password" autocomplete="new-password" matInput [required]="!data.isEditMode"
                       [(ngModel)]="data.selectedItem.password" maxlength="255" name="password">
                <mat-error>
                  {{ data.selectedItem.type === 'LDAP' ? 'Password:' : 'Client Secret:' }} is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>


            <div class="host-and-port" *ngIf="data.selectedItem.type === 'UMP'">
              <mat-checkbox name="sslEnabled1" color="primary" [(ngModel)]="data.selectedItem.sslEnabled">Use HTTPS
              </mat-checkbox>
            </div>
            <mat-form-field class="page-size" *ngIf="data.selectedItem.type !== 'UMP'">
              <mat-label>Page size</mat-label>
              <input [(ngModel)]="data.selectedItem.pageSize" matInput
                     max="{{data.selectedItem.type === 'LDAP' ? 1000: 999}}"
                     min="1" name="page-size" type="number">
            </mat-form-field>

            <div class="filter">
              <arm-form-title *ngIf="data.selectedItem.type !== 'UMP'">FILTER</arm-form-title>

              <mat-form-field class="fullWidth" *ngIf="data.selectedItem.type === 'LDAP'">
                <mat-label>Base object</mat-label>
                <textarea matInput [(ngModel)]="data.selectedItem.baseObject" name="baseObject" cdkTextareaAutosize
                          cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2"></textarea>
              </mat-form-field>

              <div class="search-filter" *ngIf="data.selectedItem.type !== 'UMP'">
                <div class="search-filter-search">
                  <mat-form-field class="fullWidth">
                    <mat-label *ngIf="data.selectedItem.type === 'LDAP'">Search object</mat-label>
                    <mat-label *ngIf="data.selectedItem.type === 'AZURE'">Filter query</mat-label>
                    <textarea matInput [(ngModel)]="data.selectedItem.searchFilter" name="searchFilter"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>


            <div class="groups-and-groups-filter">
              <div class="groups-and-users" *ngIf="data.selectedItem.type === 'AZURE'">
                <mat-checkbox name="fullGroupMembership" color="primary"
                              [(ngModel)]="data.selectedItem.fullGroupMembership"><label
                  [innerHTML]="'Fetch all groups and all their<br>members(up to 999 groups)'"></label>

                </mat-checkbox>
                <mat-hint class="groups-and-users-hint">Select this option if at least one user is a member of more
                  than
                  20 groups
                </mat-hint>
              </div>

              <mat-form-field class="fullWidth" *ngIf="data.selectedItem.type === 'AZURE'">
                <mat-label>Group Filter query</mat-label>
                <textarea matInput [(ngModel)]="data.selectedItem.groupSearchFilter" name="groupSearchFilter"
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3"
                          [disabled]='!data.selectedItem.fullGroupMembership'></textarea>
              </mat-form-field>
            </div>
            <div class="search-filter-advanced">
              <mat-checkbox *ngIf="data.selectedItem.type === 'AZURE'" name="advancedSearchFilter" color="primary"
                            [(ngModel)]="data.selectedItem.advancedSearchFilter"
                            (ngModelChange)="validateQuery()"
              >Enable advanced query capabilities
              </mat-checkbox>
            </div>
            <div class="test-connectivity-wrapper">
              <ac-button class="test-connectivity-button" (click)="testConnectivity()"
                         [ngDisabled]="!data.selectedItem.host || (data.selectedItem.type === 'LDAP' && data.selectedItem.port < 1) || (!data.isEditMode && !data.selectedItem.password)">
                Test connectivity
              </ac-button>
              <div class="connectivity-result-wrapper">
                <mat-label class="connectivity-result"
                           [class.server-connected]="connectivity && connectivity.availableAttributes"
                           *ngIf="connectivity">{{ connectivity.status }}
                </mat-label>
              </div>
            </div>
            <mat-error *ngIf="this.invalidQueryMsg !='' ">
              {{ this.invalidQueryMsg }}
            </mat-error>
          </div>

          <div class="ssl-configuration">
            <div class="ssl-configuration-inner">
              <div *ngIf="data.selectedItem.type === 'LDAP' ">
                <arm-form-title>SSL CONFIGURATIONS</arm-form-title>
                <mat-checkbox name="sslEnabled" color="primary" [(ngModel)]="data.selectedItem.sslEnabled">Enable SSL
                </mat-checkbox>

                <ac-input-container label="Certificate File">
                  <ac-file-picker alternativeName="server.certificate"
                                  (acChanged)="onFileChange($event)"
                                  [ngDisabled]="!data.selectedItem.sslEnabled"
                                  [inputDisable]="true"
                                  [filePickerButtonText]="'Browse'">
                  </ac-file-picker>
                </ac-input-container>

                <div class="certificate" *ngIf="data.isEditMode && data.selectedItem.parsedCertificate">
                  <span (click)="openCertificateView()">View loaded certificate</span>
                </div>
              </div>
            </div>

            <mat-tab [label]="propertiesTabName"
                     [disabled]="!data.selectedItem.host || (data.selectedItem.type === 'LDAP' && data.selectedItem.port < 1)  || (!data && !!data.selectedItem.password)
                    || (!data.selectedItem.id && !data.selectedItem.password)">
              <div class="properties-tab-content">
                <div id="no-connectivity-warning"
                     *ngIf="isTestConnectivityReady && (!connectivity || !connectivity.availableAttributes)">
                  <mat-label>Mapping properties are not available since the server cannot be connected</mat-label>
                </div>

                <div id="servers-properties-step"
                     *ngIf="isTestConnectivityReady && connectivity && connectivity.availableAttributes">
                  <div class="arm-list-servers-properties">
                    <div *ngFor="let mapping of data.selectedItem.dicAttrMapping; let i = index">
                      <div class="arm-list-item">
                        <div class="attribute-name">
                          <mat-label>
                            {{ mapping.dicAttrName }}
                          </mat-label>
                        </div>

                        <ac-input-container
                          label="{{data.selectedItem.type === 'LDAP' ? 'LDAP' : data.selectedItem.type === 'AZURE' ? 'Azure AD' : 'UMP'}}
                        mapping" class="ldap-mapping-ad-attr">
                          <ac-select [acModel]="mapping.aDAttrName"
                                     [searchable]="true"
                                     allowClear="true"
                                     (acModelChange)="mapping.aDAttrName = $event; this.validateQuery()"
                                     [addCustomTags]="true"
                                     [items]="adAttributes"
                                     bindLabel="value"
                                     bindValue="text">
                          </ac-select>
                        </ac-input-container>

                        <ac-input-container label="Attribute normalization" class="ldap-mapping-ad-attr">
                          <ac-select [acModel]="mapping.normalizationGroupId" class="ldap-mapping-normalization"
                                     allowClear="true"
                                     (acModelChange)="mapping.normalizationGroupId = $event"
                                     [items]="data.normalizationGroupsOptions"
                                     bindLabel="groupName"
                                     bindValue="id">
                          </ac-select>
                        </ac-input-container>

                      </div>
                      <div class="items-divider">
                        <mat-divider></mat-divider>
                      </div>
                    </div>
                  </div>
                  <mat-error *ngIf="this.invalidQueryMsg !='' ">
                    {{ this.invalidQueryMsg }}
                  </mat-error>
                </div>
              </div>
            </mat-tab>
            <mat-tab [label]="updatesTabName">
              <div class="updates-configuration">
                <arm-form-title>Updates</arm-form-title>
                  <!-- For AZURE type, show the radio button to select update mode -->

                    <div *ngIf="data.selectedItem.type === 'AZURE'" class="update-mode-radio-group">
                      <label>
                        <input type="radio" name="updateMode"
                               [(ngModel)]="data.selectedItem.useMinuteUpdate"
                               [value]="false">
                        Standard Scheduling
                      </label>
                      <label>
                        <input type="radio" name="updateMode"
                               [(ngModel)]="data.selectedItem.useMinuteUpdate"
                               [value]="true">
                        Minute-Based Scheduling
                      </label>
                    </div>
                <div class="updates-wrapper">


                    <mat-form-field
                    *ngIf="(data.selectedItem.type === 'LDAP' || data.selectedItem.type === 'UMP') || (data.selectedItem.type === 'AZURE' && data.selectedItem.useMinuteUpdate) ">
                    <mat-label>Check for updates every (min)</mat-label>
                    <input [(ngModel)]="data.selectedItem.syncIntervalMinutes" matInput
                           min="1" name="syncIntervalMinutes" type="number">
                  </mat-form-field>

                  <mat-form-field
                    *ngIf="data.selectedItem.type !== 'UMP' && (data.selectedItem.type !== 'AZURE' || !data.selectedItem.useMinuteUpdate)">
                    <mat-label>Perform full update every (days)</mat-label>
                    <input [(ngModel)]="data.selectedItem.fullSyncIntervalInDays" matInput
                           min="1" name="fullSyncIntervalInDays" type="number">
                  </mat-form-field>

                  <div class="updates-wrapper-at"
                       *ngIf="data.selectedItem.type !== 'UMP' && (data.selectedItem.type !== 'AZURE' || !data.selectedItem.useMinuteUpdate)">
                    <mat-form-field class="updates-wrapper-at-hour">
                      <mat-label>At</mat-label>
                      <input [(ngModel)]="data.selectedItem.fullSyncHour" matInput
                             min="0" max="23" name="fullSyncHour" type="number">
                    </mat-form-field>
                    <span> : </span>
                    <mat-form-field class="updates-wrapper-at-min">
                      <input [(ngModel)]="data.selectedItem.fullSyncMinute" matInput
                             min="0" max="59" name="fullSyncMinute" type="number">
                    </mat-form-field>
                  </div>

                  <div class="updates-timeouts"  *ngIf="data.selectedItem.type !== 'AZURE'">
                    <mat-form-field>
                      <mat-label>Sync timeout (min)</mat-label>
                      <input [(ngModel)]="data.selectedItem.timeout" matInput
                             min="1" name="timeout" type="number">
                    </mat-form-field>

                    <mat-form-field class="read-timeout">
                      <mat-label>Query Timeout (seconds)</mat-label>
                      <input [(ngModel)]="data.selectedItem.readTimeout" matInput
                             min="1" max="10000" name="readTimeout" type="number">
                    </mat-form-field>
                  </div>

                  <div class="updates-timeouts" *ngIf="data.selectedItem.type === 'AZURE'" >
                    <mat-form-field class="fullWidth">
                      <mat-label>Sync timeout (min)</mat-label>
                      <input [(ngModel)]="data.selectedItem.timeout" matInput
                             min="1" name="timeout" type="number">
                    </mat-form-field>

                  </div>



                </div>
              </div>
            </mat-tab>
          </div>
        </form>
      </div>
    </mat-tab>
  </mat-tab-group>
</arm-dialog>
